import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import axiosInstance from "../../../../../services/api/API";
import {
  toastError,
  toastSuccess,
} from "../../../../../customComponents/customToast/Toast";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";
import validations from "../../../../../../helpers/validations";

const AddNewDealer = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  // const authToken = localStorage.getItem("authToken");
  const authToken = sessionStorage.getItem("u_t");
  const [userTypedd, setUserTypedd] = useState([]);
  const [salesPersonOptions, setSalesPersonOptions] = useState([]);

  const [cityOptions, setCityOptions] = useState([]);
  const [pincode, setPincode] = useState("");

  const [roledd, setRoledd] = useState([]);
  const userType = localStorage.getItem("UserType");
  // console.log(userType, "USERTYPE");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    roleDropdown();
  }, []);

  const roleDropdown = async () => {
    try {
      const payload = {
        business_partner_id:
          userType === "superadmin"
            ? formData?.business_partner_id
            : businessPartnerId,
      };

      const response = await axiosInstance.post("/role/ddlrole", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const roleOptions = data.map((role) => ({
        value: role.ID,
        label: role.NAME,
      }));
      setRoledd(roleOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    // console.log("dealerformdata", formData);

    const errors = {};
    let isValid = true;

    DealerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this dealer?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const payload = new FormData();

          payload.append("dealer_code", formData.dealer_code || "");
          payload.append("dealer_name", formData.dealer_name);
          // payload.append("dealer_desc", formData.dealer_desc);
          payload.append("contact_no", formData.contact_no);
          // payload.append("sales_person_id", formData.sales_person_name);
          payload.append("dealer_address", formData.dealer_address);
          payload.append("email_id", formData.email_id);
          // payload.append("tin", formData.tin);
          payload.append("password", formData.password || "");
          payload.append("country_id", formData.country_id);
          payload.append("state_id", formData.state_id);
          payload.append("city_id", formData.city_id);
          payload.append("dealer_pin_code", formData.pincode);
          payload.append(
            "is_on_created",
            formData.is_on_created === true ? 1 : 0,
          );
          payload.append(
            "is_partial_payment",
            formData.is_partial_payment === true ? 1 : 0,
          );
          // payload.append("role_id", formData.role_id);
          payload.append("status", formData.status === true ? 1 : 0);

          if (formData.pan) {
            payload.append("pan", formData.pan);
          }
          // payload.append("pan", formData.pan);
          if (formData.gst) {
            payload.append("gst", formData.gst);
          }
          // payload.append("gst", formData.gst);

          // Append images if present
          if (formData.pan_image) {
            payload.append("pan_image", formData.pan_image);
          }
          if (formData.gst_image) {
            payload.append("gst_image", formData.gst_image);
          }
          if (formData.trade_license) {
            payload.append("trade_license", formData.trade_license);
          }
          if (formData.bank_doc) {
            payload.append("bank_doc", formData.bank_doc);
          }
          // API call to create a dealer
          const response = await axiosInstance.post("/dealer/create", payload, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${authToken}`,
            },
          });

          if (response.status === 200) {
            Swal.fire({
              title: "Success",
              text: "Dealer added successfully!",
              icon: "success",
              confirmButtonText: "OK",
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(() => {
              navigate(ROUTES_NAVIGATION.DEALERLIST);
            });
          }
        } catch (error) {
          // console.error("Error adding dealer:", error);

          const status = error.response?.status;
          let errorMessage =
            error.response?.data?.message ||
            "An error occurred while processing your request.";

          // If backend indicates record exists, show friendly message
          if (
            status === 403 ||
            (typeof errorMessage === "string" &&
              /already exists/i.test(errorMessage))
          ) {
            errorMessage =
              "A dealer with this email ID or contact number already exists.";
          }

          Swal.fire({
            title: "Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: "Cancelled",
          text: "The dealer was not added.",
          icon: "info",
          confirmButtonText: "OK",
        });
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    salesPersonDropdown();
  }, []);

  const salesPersonDropdown = async () => {
    try {
      const response = await axiosInstance.get("/salesperson/ddlSalesperson", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response?.data?.data;

      const dealerOptions = data.map((dealer) => ({
        value: dealer.sales_person_id,
        label: dealer.sales_person_name,
      }));

      setSalesPersonOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const generateRandomPassword = (length = 10) => {
      const chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";
      let password = "";
      for (let i = 0; i < length; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return password;
    };

    const randomPassword = generateRandomPassword();

    setFormData((pre) => ({
      ...pre,
      password: randomPassword,
    }));
  }, []);

  // useEffect(() => {
  //   console.log(formData, "dealerFormDAta");
  // });

  const DealerInputs = [
    {
      name: "dealer_code",
      label: "Dealer Code",
      type: "text",
      disabled: true,
      gridClass: "col-lg-4",
      placeholder: "Enter Dealer Code",
      validation: validations.dealerCode({}),
    },
    {
      name: "dealer_name",
      label: "Dealer Name",
      placeholder: "Enter Dealer Name",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.dealerName({ required: true }),
    },
    {
      name: "contact_no",
      label: "Contact No.",
      placeholder: "Enter Contact No.",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.mobile({ required: true }),
    },
    {
      name: "dealer_address",
      label: "Dealer Address",
      placeholder: "Enter Dealer Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.address({ required: true }),
    },
    {
      name: "email_id",
      label: "Email ID",
      placeholder: "Enter Email Address",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.email({ required: true }),
    },
    {
      name: "password",
      label: "Password",
      placeholder: "Enter Password",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
      disabled: true,
    },
    {
      name: "pan",
      label: "PAN No.",
      type: "text",
      placeholder: "Enter Pan No.",
      validation: validations.pan({ required: false }),
      required: false,
      gridClass: "col-lg-4",
    },
    {
      name: "gst",
      label: "GST No.",
      type: "text",
      placeholder: "Enter GST No.",
      validation: validations.gst({ required: false }),
      required: false,
      gridClass: "col-lg-4",
    },
    {
      name: "pincode",
      label: "Pin Code",
      placeholder: "Enter Pin Code",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: validations.pincode({ required: true }),
    },
    {
      name: "city",
      label: "City",
      placeholder: "City",
      type: "text",
      // options: cityOptions,
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "state",
      label: "State",
      placeholder: "State",
      type: "text",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Country",
      type: "text",
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
      disabled: true,
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      // required: true,
      // validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "pan_image",
      label: "Pan Image",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "gst_image",
      label: "GST Image",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
    {
      name: "trade_license",
      label: "Trade License",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
    {
      name: "bank_doc",
      label: "Dealership Agreement",
      type: "file",
      allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
      // required: true,
      gridClass: "col-lg-4",
      // validation: { required: true },
    },
    // {
    //   name: "dealership_agreement",
    //   label: "Dealership Agreement",
    //   type: "file",
    //   allowedExtensions: ["jpg", "jpeg", "png", "pdf"],
    //   // required: true,
    //   gridClass: "col-lg-4",
    //   // validation: { required: true },
    // },
  ];

  // useEffect(() => {
  //   console.log(formData, "formDataDealer");
  // });

  useEffect(() => {
    if (pincode.length === 6 || formData?.pincode?.length === 6) {
      const fetchPincodeData = async () => {
        try {
          const response = await axiosInstance.post(
            "/pincodestatecity/getbypincode",
            {
              pincode: pincode,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          if (response.status === 200) {
            const data = response?.data?.data[0];

            // Check for empty data
            if (!data) {
              // Set validation error for pincode
              // setValidationErrors((prevErrors) => ({
              //   ...prevErrors,
              //   pincode: "Invalid Pincode*",
              // }));
              setFormData((prevData) => ({
                ...prevData,
                city: "",
                state: "",
                country: "",
              }));
            } else {
              // If valid, update formData and clear any previous pincode validation error
              setFormData((prevData) => ({
                ...prevData,
                city: data?.city_name,
                city_id: data?.city_id,
                state: data?.state_name,
                state_id: data?.state_id,
                country: data?.country_name,
                country_id: data?.country_id,
              }));

              setValidationErrors((prevErrors) => ({
                ...prevErrors,
                pincode: "", // Clear pincode error if valid
              }));
            }
          } else {
            throw new Error("Failed to fetch data");
          }
        } catch (error) {
          // console.error("Error fetching data:", error);
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            pincode: "Failed to fetch data", // Set error message if request fails
          }));
        }
      };

      fetchPincodeData();
    }
  }, [pincode]);

  useEffect(() => {
    if (formData?.pincode?.length === 6) {
      setPincode(formData?.pincode);
    }
  }, [formData?.pincode]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="backbutton mt-2 mb-2">
            <img
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }}
              src={backicon}
              alt="back"
            />
            <span className="backbtntitle">Add New Dealer</span>
          </div>
          <div className="form-container">
            <span className="cust-det-title mt-2 mb-2">
              Please Enter Dealer Details
            </span>
            <DynamicForm
              formConfig={DealerInputs}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              cityOptions={cityOptions}
              setCityOptions={setCityOptions}
            />
          </div>
          <div className="btncontainer mt-3">
            <button
              onClick={() => {
                handleFormSubmit(formData);
              }}
              className="submit-btn"
              disabled={
                !isFormValid(DealerInputs, formData, validationErrors) ||
                loading
              }
              style={buttonStyle(
                DealerInputs,
                formData,
                validationErrors,
                loading,
              )}
            >
              {loading ? "Processing..." : "Submit"}
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default AddNewDealer;
